<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm) ">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-card-plus"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingCard"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.code"
                        >
                          <v-text-field
                            v-model="card.code"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.code')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.name"
                        >
                          <v-text-field
                            v-model="card.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="card.priceCost"
                        >
                          <v-text-field
                            v-model.number="card.priceCost"
                            outlined
                            name="card.priceSell"
                            :label="$t('fields.card.priceCost')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="card.priceSell"
                        >
                          <v-text-field
                            v-model.number="card.priceSell"
                            outlined
                            name="card.priceSell"
                            :label="$t('fields.card.priceSell')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.cardType"
                        >
                          <v-text-field
                            v-model="card.cardType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.cardType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.artType"
                        >
                          <v-text-field
                            v-model="card.artType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.artType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.printType"
                        >
                          <v-text-field
                            v-model="card.printType"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.printType')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.edition"
                        >
                          <v-text-field
                            v-model="card.edition"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.edition')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="card.language"
                        >
                          <v-text-field
                            v-model="card.language"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.card.language')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.state"
                        >
                          <v-switch
                            v-model="card.state"
                            class="mx-2"
                            :label="$t('fields.card.state')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|numeric"
                          name="card.inventory"
                        >
                          <v-text-field
                            v-model.number="card.inventory"
                            outlined
                            name="card.inventory"
                            :label="$t('fields.card.inventory')"
                            :error-messages="errors"
                            color="secondary"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.categoryId"
                        >
                          <v-select
                            v-model="card.rarityId"
                            :items="gameRarities"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.rarityId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.gameLineId"
                        >
                          <v-select
                            v-model="card.gameLineId"
                            :items="gameLines"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.gameLineId')"
                            :error-messages="errors"
                            outlined
                            @change="changeGame(card.gameLineId)"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="card.gameExpansionId"
                        >
                          <v-select
                            v-model="card.gameExpansionId"
                            :items="gameExpansions"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.card.gameExpansionId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <!-- sections -->
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          name="card.sections"
                        >
                          <v-select
                            v-model="card.sectionsId"
                            :items="sections"
                            item-text="title"
                            item-value="id"
                            :label="$t('fields.card.sections')"
                            :error-messages="errors"
                            multiple
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                      style="max-width: 500px;"
                    >
                      <v-col
                        cols="auto"
                        class="text-center"
                      >
                        <input
                          ref="file"
                          type="file"
                          class="d-none"
                          @change="selectImage"
                        >
                        <div class="font-weight-bold grey--text">
                          Selecciona una imagen
                        </div>
                        <v-card
                          :class="imagePreview ? 'success--text' : 'grey--text'"
                          class="mx-auto mt-0 d-inline-flex v-card--account"
                          outlined
                          height="400"
                          width="300"
                          @click="$refs.file.click()"
                        >
                          <v-img
                            v-if="imagePreview"
                            :src="imagePreview"
                            height="100%"
                            width="100%"
                          />
                          <v-icon
                            v-else
                            class="mx-auto"
                            size="96"
                          >
                            mdi-account
                          </v-icon>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  // import axios from 'axios'
  import { repositoryFactory } from '@/api/repositoryFactory'
  // import store from './../../../store'
  // const baseDomain = process.env.VUE_APP_API_BASE_URL
  // const baseURL = `${baseDomain}/api/card`
  // var axiosConnectionCard = axios.create({
  //   baseURL,
  //   headers: {
  //     // 'content-Type': 'multipart/form-data',
  //     Authorization: `Bearer ${store.state.jwtToken}`,
  //   },
  //   // headers: { Authorization: `Bearer ${store.state.jwtToken}` },
  // })
  const cardsRespository = repositoryFactory.get('cards')
  const gameRaritiesRepository = repositoryFactory.get('gameRarities')
  const gameLinesRepository = repositoryFactory.get('gameLines')
  const gameExpansionsRepository = repositoryFactory.get('gameExpansions')
  const sectionsRepository = repositoryFactory.get('sections')

  export default {
    inject: ['theme'], // ??
    name: 'CardCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      card: {
        state: true,
      },
      imagePreview: null,
      imageBytes: null,
      sections: [],
      gameRarities: [],
      gameLines: [],
      gameExpansions: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingCard: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-card') : this.$t('modify-card')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingCard = true
        var id = this.$route.params.id
        cardsRespository.getById(id).then(response => {
          self.loadingCard = false
          self.card = Object.assign({}, response.data.data)
          console.log(self.card)
          if (self.card.sections != null) {
            self.card.sectionsId = self.card.sections.map((x) => x.id)
          }
          if (self.card.cardImage.length > 0) {
            self.imagePreview = self.card.cardImage[0].url
          }
          if (self.card.gameLineId != null) {
            this.getExpansions(self.gameLineId)
          }
        }).catch(err => {
          self.loadingCard = false
          alert(err)
        })
      }
      this.getRarities()
      this.getGames()
      this.getSections()
    },
    methods: {
      // submitForm (scope) {
      //   var self = this
      //   var formData = new FormData()
      //   formData.append('request', JSON.stringify(this.card))
      //   // formData.append('code', this.card.code)
      //   // formData.append('name', this.card.name)
      //   // formData.append('cardType', this.card.cardType)
      //   // formData.append('artType', this.card.artType)
      //   // formData.append('printType', this.card.printType)
      //   // formData.append('edition', this.card.edition)
      //   // formData.append('language', this.card.language)
      //   // formData.append('priceSell', this.card.priceSell)
      //   // formData.append('priceCost', this.card.priceCost)
      //   // formData.append('state', this.card.state)
      //   // formData.append('inventory', this.card.inventory)
      //   // formData.append('rarityId', this.card.rarityId)
      //   // formData.append('gameLineId', this.card.gameLineId)
      //   // formData.append('gameExpansionId', this.card.gameExpansionId)
      //   formData.append('imageBytes', this.imageBytes, this.imageBytes.name)
      //   // var data = {
      //   //   data: this.card,
      //   // }
      //   self.loadingSave = true
      //   if (self.formAction !== 'add') {
      //     axiosConnectionCard.put(`${this.card.id}`, formData)
      //       .then(response => {
      //         if (response.data.isValid) {
      //           self.goToList()
      //         } else {
      //           self.showErrorMessage = true
      //           self.errorMessage = response.data.errorMessages[0]
      //         }
      //         self.loadingSave = false
      //       })
      //       .catch(err => {
      //         self.errorMessage = err
      //         self.showErrorMessage = true
      //         self.loadingSave = true
      //       })
      //   } else {
      //     // agregar nueva carta
      //     axiosConnectionCard.post('', formData)
      //       .then(response => {
      //         if (response.data.isValid) {
      //           self.goToList()
      //           self.formAction = 'modify'
      //         } else {
      //           self.showErrorMessage = true
      //           self.errorMessage = response.data.errorMessages[0]
      //         }
      //         self.loadingSave = false
      //       })
      //       .catch(err => {
      //         self.errorMessage = err
      //         self.showErrorMessage = true
      //         self.loadingSave = false
      //       })
      //   }
      // },
      submitForm (scope) {
        var self = this
        if (this.card.sectionsId != null) {
          this.card.sections = this.card.sectionsId.map((x) => {
            return {
              id: x,
              title: '',
            }
          })
        }
        var data = new FormData()
        data.append('data', JSON.stringify(this.card))
        if (this.imageBytes != null) {
          data.append('imageBytes', this.imageBytes, this.imageBytes.name)
        } else {
          data.append('imageBytes', null)
        }

        // var data = {
        //   data: this.card,
        // }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          data.append('id', this.card.id)
          cardsRespository.updateCard(data, this.card.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          console.log(data)
          cardsRespository.addCard(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      selectImage (val) {
        var self = this
        const value = val.target.files[0]
        if (!value) return (self.imagePreview = null)
        self.imagePreview = URL.createObjectURL(value)
        self.imageBytes = value
      },
      getRarities () {
        var self = this
        gameRaritiesRepository.get().then(response => {
          self.gameRarities = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getGames () {
        var self = this
        gameLinesRepository.get().then(response => {
          self.gameLines = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getExpansions () {
        var self = this
        gameExpansionsRepository.get().then(response => {
          self.gameExpansions = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      getSections () {
        var self = this
        sectionsRepository.get().then(response => {
          self.sections = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      changeGame (gameId) {
        this.getExpansions(gameId)
        this.card.gameExpansionId = null
      },
      goToList () {
        this.$router.push({ name: 'cards' })
      },
    },
  }
</script>
